import store from "@/store";

export default (permissionName) => {
  return store.getters["acl/GetCan"](permissionName);
};
